import { render, staticRenderFns } from "./versionMarketing.vue?vue&type=template&id=3a52f6f1&scoped=true&"
import script from "./versionMarketing.vue?vue&type=script&lang=js&"
export * from "./versionMarketing.vue?vue&type=script&lang=js&"
import style0 from "./versionMarketing.vue?vue&type=style&index=0&id=3a52f6f1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a52f6f1",
  null
  
)

export default component.exports